import { useEffect, useState } from 'react';
import { supabase } from '../../services/supabaseService';
import ProjectMaintenance from './ProjectMaintenance';

type AssignedMaintenance = { id: string; project_id: string; project_name: string; client_name: string; plan_name: string; status: string; monthly_hours: number };
const statuses: Record<string, string> = { active: 'Activo', paused: 'Pausado', cancelled: 'Cancelado' };

export default function MyMaintenances() {
  const [items, setItems] = useState<AssignedMaintenance[]>([]);
  const [selected, setSelected] = useState<AssignedMaintenance | null>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    void (async () => {
      try {
        const { data, error: failure } = await supabase.rpc('get_my_maintenances');
        if (failure) throw failure;
        if (active) setItems(data || []);
      } catch (e) { if (active) setError((e as Error).message || 'No se pudieron cargar los mantenimientos'); }
      finally { if (active) setLoading(false); }
    })();
    return () => { active = false; };
  }, []);
  if (selected) return <div className="space-y-5">
    <button className="text-blue-700" onClick={() => setSelected(null)}>← Mis mantenimientos</button>
    <h1 className="text-2xl font-semibold">{selected.project_name}</h1>
    <ProjectMaintenance key={selected.id} projectId={selected.project_id} projectName={selected.project_name} clientName={selected.client_name} team={[]} canManage={false} />
  </div>;
  return <section className="space-y-5">
    <h1 className="text-2xl font-semibold">Mis mantenimientos</h1>
    <p className="text-gray-600">Tus proyectos de mantenimiento. Registra tus horas y consulta el trabajo de tus compañeros y la bolsa compartida.</p>
    {error && <p role="alert" className="text-red-700">{error}</p>}
    {loading ? <p role="status">Cargando mantenimientos…</p> : !error && !items.length ? <p>No tienes mantenimientos asignados.</p> : <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
      {items.map(item => <button key={item.id} onClick={() => setSelected(item)} className="text-left border rounded-xl p-5 bg-white hover:border-blue-500 space-y-2">
        <h2 className="text-lg font-semibold">{item.project_name}</h2><p>{item.client_name} · {item.plan_name}</p>
        <p>{item.monthly_hours} h / mes compartidas · {statuses[item.status] || item.status}</p>
        <span className="text-blue-700 block">Ver mantenimiento →</span>
      </button>)}
    </div>}
  </section>;
}
